import type { ReactNode } from 'react';
import type { BuilderStep } from '../../lib/types.js';
import { AddStepMenu } from './AddStepMenu.js';
import type { StepPath } from './definitionEdit.js';
import type { StepListContext } from './stepTypes.js';
export interface StepArmProps {
  label: string;
  emptyText: string;
  steps: BuilderStep[];
  containerPath: StepPath;
  ctx: StepListContext;
  /** The case's condition editor — branch cases only; approval arms and
   * Otherwise have no condition of their own. */
  when?: React.ReactNode;
  onRemoveArm?: () => void;
  onRenameArm?: (v: string) => void;
}
export interface StepArmViewProps extends StepArmProps {
  children?: ReactNode;
}
export const StepArm = ({
  label,
  emptyText,
  steps,
  children,
  containerPath,
  ctx,
  when,
  onRemoveArm,
  onRenameArm,
}: StepArmViewProps) => {
  return (
    <div className="rounded-lg border border-outline bg-surface-elevated/70 p-3">
      <div className="mb-2 flex items-center gap-2">
        {onRenameArm ? (
          <input
            aria-label="Case label"
            value={label}
            onChange={(e) => onRenameArm(e.target.value)}
            className="w-44 rounded border border-transparent bg-transparent text-[0.72rem] font-semibold uppercase tracking-wider text-ink-subtle hover:border-outline focus:border-outline focus:outline-none"
          />
        ) : (
          <span className="text-[0.72rem] font-semibold uppercase tracking-wider text-ink-subtle">
            {label}
          </span>
        )}
        {onRemoveArm && (
          <button
            type="button"
            aria-label={`Remove case ${label}`}
            className="text-xs text-ink-subtle hover:text-danger"
            onClick={onRemoveArm}
          >
            ✕
          </button>
        )}
      </div>
      {when && (
        <div className="mb-3 grid min-w-0 gap-1.5">
          <span className="text-[0.68rem] font-semibold uppercase tracking-wider text-ink-subtle">
            When
          </span>
          {when}
          <span className="mt-1 text-[0.68rem] font-semibold uppercase tracking-wider text-ink-subtle">
            Then do
          </span>
        </div>
      )}
      {steps.length === 0 ? <p className="mb-2 text-xs text-ink-subtle">{emptyText}</p> : children}
      <div className="mt-2">
        <AddStepMenu containerPath={containerPath} ctx={ctx} compact />
      </div>
    </div>
  );
};
